module.exports = __webpack_public_path__ + "static/media/screen1.9cd93ef5.png";